import ReduxThunk from "redux-thunk";
import logger from "redux-logger";
import { applyMiddleware, createStore } from "redux";
import { createPromise } from "redux-promise-middleware";
import reducer from "./Reducers";

const middleWare = applyMiddleware(createPromise({}), ReduxThunk, logger);

export default createStore(reducer, middleWare);
